<template>
    <hm-content>
        <div class="flex flex-end">
            <el-select
                placeholder="请选择审核状态"
                size="small"
                class="mr10"
                v-model="conditionQuery.value2"
                clearable
            >
                <el-option
                    v-for="(v,i) in postStatus"
                    :label="v.label"
                    :value="v.value"
                    :key="i"
                ></el-option>
            </el-select>
            <el-date-picker
                    clearable
                    placeholder="请选择时间段"
                    size="small"
                    class="mr10"
                    v-model="conditionQuery.time"
                    type="datetimerange"
                    align="right"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['12:00:00', '08:00:00']">
            </el-date-picker>
            <el-input
                    clearable
                    size="small"
                    class="mr10"
                    placeholder="请输入订单号"
                    v-model="conditionQuery.goodsSn"
            ></el-input>
            <el-button
                    size="small"
                    class="mr10"
                    type="primary"
            >查询</el-button>
        </div>
        <div>
            <el-table
                :data="table"
            >
                <el-table-column

                ></el-table-column>
            </el-table>
        </div>
    </hm-content>
</template>
<script>
    export default {
        data(){
            return{
                table:[],
                postStatus:[
                    {
                        label:'通过',
                        value:'yes'
                    },
                    {
                        label:'驳货',
                        value:'no'
                    },],//提现状态
                conditionQuery:{    //查询条件
                    value2:'',
                    time:'',
                    goodsSn:''
                }
            }
        }
    }
</script>
<style scoped lang="scss"></style>